const map = {
	"./Logo.png": 406,
	"./bioimg.jpg": 528,
	"./mainimg.jpg": 327,
	"./photo_11_2026-09-29_16-37-32.jpg": 422,
	"./photo_12_2026-09-29_16-15-18.jpg": 229,
	"./photo_12_2026-09-29_16-37-32.jpg": 969,
	"./photo_13_2026-09-29_16-15-18.jpg": 308,
	"./photo_17_2026-09-29_16-15-18.jpg": 248,
	"./photo_17_2026-09-29_16-37-32.jpg": 428,
	"./photo_18_2026-09-29_16-15-18.jpg": 443,
	"./photo_18_2026-09-29_16-37-32.jpg": 359,
	"./photo_1_2026-09-29_16-15-18.jpg": 195,
	"./photo_20_2026-09-29_16-15-18.jpg": 234,
	"./photo_21_2026-09-29_16-37-32.jpg": 463,
	"./photo_23_2026-09-29_16-37-32.jpg": 665,
	"./photo_25_2026-09-29_16-15-18.jpg": 111,
	"./photo_25_2026-09-29_16-37-32.jpg": 747,
	"./photo_26_2026-09-29_16-15-18.jpg": 24,
	"./photo_26_2026-09-29_16-37-32.jpg": 756,
	"./photo_27_2026-09-29_16-15-18.jpg": 801,
	"./photo_27_2026-09-29_16-37-32.jpg": 333,
	"./photo_29_2026-09-29_16-15-18.jpg": 387,
	"./photo_29_2026-09-29_16-37-32.jpg": 31,
	"./photo_2_2026-09-29_16-15-18.jpg": 444,
	"./photo_30_2026-09-29_16-15-18.jpg": 561,
	"./photo_30_2026-09-29_16-37-32.jpg": 413,
	"./photo_31_2026-09-29_16-15-18.jpg": 232,
	"./photo_32_2026-09-29_16-15-18.jpg": 492,
	"./photo_33_2026-09-29_16-37-32.jpg": 250,
	"./photo_3_2026-09-29_16-15-18.jpg": 261,
	"./photo_4_2026-09-29_16-15-18.jpg": 510,
	"./photo_5_2026-09-29_16-15-18.jpg": 831,
	"./photo_6_2026-09-29_16-37-32.jpg": 100,
	"./photo_7_2026-09-29_16-15-18.jpg": 65,
	"./photo_8_2026-09-29_16-15-18.jpg": 426,
	"./photo_9_2026-09-29_16-15-18.jpg": 883,
	"./photo_9_2026-09-29_16-37-32.jpg": 375
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 941;